<template>
  <div class="clearfix rounded">

    <b-modal id="pinch-in-or-out-modal" size="md" hide-footer :title="p_i_o_b_label">
      <b-form @submit.stop.prevent="submitWithLocation">

        <b-form-group>
          <b-form-input disabled :value="selectedLocation.location"></b-form-input>
        </b-form-group>
        <b-form-group v-if="selectedLocation.allow_specify == 1" label="Please Specify">
          <b-form-textarea id="remarks" name="remarks" rows="3" max-rows="6" no-resize v-model="fdata.remarks" data-vv-as="remarks"></b-form-textarea>
        </b-form-group>
        <b-button type="submit" :disabled="freezeFlag">
          {{p_i_o_b_label}}
        </b-button>
      </b-form>
    </b-modal>

    <b-dropdown  :disabled="freezeFlag" v-if="mobility" id="dropdown-1" :text="p_i_o_b_label">
      <b-dropdown-item v-for="location in locations" :key="location.id" @click="showPunchInOutModal(location.id)">{{location.location}}</b-dropdown-item>
    </b-dropdown>

  </div>
</template>
<script>
import moment from 'moment'
export default{
  mounted() {

  },
  props: [ 'flg'],
  components: {},


  data()
  {
    return {
      p_i_o_b_label : 'Loading..',
      freezeFlag: false,
      cookie_btn_click_time: '',
      mobility: 0,
      locations:[],
      selectedLocation: {id:null, location:null},
      fdata:{
        remarks:'',
      }

    }
  },

  methods:{
    submitWithLocation(){
      if(this.freezeFlag == false)
      {
        let formData = new FormData()
        formData.append('mobility_id',this.selectedLocation.id)
        formData.append('remarks',this.fdata.remarks)
        axios.post(this.$api_url+'/front/employee/attendance/mobile/punchinorout' , formData).then(response => {
          // inner if
          if(response.data){
            this.$emit('childToParent',response.data);
            this.$bvToast.toast('Saved!', {
              title: `Punched Successfully`,
              variant: 'success',
              solid: true
            });
            if(response.data.last_activity == 'in'){
              this.p_i_o_b_label = 'Punch Out';
            }
            else
            {
              this.p_i_o_b_label = 'Punch In';
            }
            // end of inner if
            this.freezeFlag = true;
            setTimeout( () => {
                  this.freezeFlag = false
                },
                1000);

            location.reload();
          }

        }).catch(error => { this.serverError(error);});
      }
    },
    getMobilityLocations(){
      axios.get(this.$api_url+'/front/attendance-mobility',{
        params:{
          type: 'list'
        }
      }).then(response => {
        this.locations = response.data;

      }).catch(error => {this.serverError(error);});
    },

    showPunchInOutModal(location){
      this.selectedLocation = this.locations.find(el => el.id == location)
      this.$bvModal.show('pinch-in-or-out-modal')
    },

    getPunchedInOrOut: function() {
      let currentObj = this;
      axios.get(this.$api_url+'/front/employee/attendance/get-punchedinorout').then(response => {
          // Immediately freeze the button
          currentObj.freezeFlag = true;

          if(response.data.data != null){
            let activity_logs = response.data.data.activity_log.split(',');
            let lastLog = activity_logs[activity_logs.length - 1] || "00:00";
            let today = new Date();
            let [hh, mm] = lastLog.split(':');
            let lastPunchTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), hh, mm, '00');

            const now = new Date();
            const diffMs = now - lastPunchTime;
            const diffMinutes = Math.floor(diffMs / (1000 * 60));
            
            // If last punch was less than 1 minute ago, set 1 minute cooldown
            // Otherwise, no cooldown needed
            const cooldownNeeded = diffMinutes < 1;
            
            if (cooldownNeeded) {
                  // Calculate remaining cooldown time in ms
                  const remainingCooldown = (60 * 1000) - diffMs;
                  setTimeout(() => {
                      currentObj.freezeFlag = false;
                  }, remainingCooldown);
            } 
            else
            {
              currentObj.freezeFlag = false;
            }
          }
          else
          {
            currentObj.freezeFlag = false;
          }

          currentObj.mobility = response.data.attendance_mobility;
          if(currentObj.mobility)
          {
            this.getMobilityLocations();
          }
          
          if(response.data.last_activity == 'in') {
                this.p_i_o_b_label = 'Punch Out';
          } else {
                this.p_i_o_b_label = 'Punch In';
          }
      }).catch(error => { 
          currentObj.serverError(error);
      });
    },


  },
  created: function(){

    this.getPunchedInOrOut();
  },
}
</script>
